import React, { FunctionComponent, ReactNode, useContext } from 'react';
import styles from './styles.module.scss';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { IconLink } from 'components/Buttons/IconLink';
import { LogoImage } from 'components/LogoImage';
import { useDispatch } from 'react-redux';
import { setMiniPlayerVisible } from 'features/channel/channelSlice';
import { ThumbImage } from 'components/Images/ThumbImage';
import { SupportButton } from 'components/Support/SupportButton';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { FollowButtons } from 'features/chat/components/FollowButtons';
import { useCurrentUser } from 'features/current-user/hooks';

interface FullScreenHeaderProps {
  minimiseUrl?: string;
  statusPill?: ReactNode;
}

export const FullScreenHeader: FunctionComponent<FullScreenHeaderProps> = (
  props
) => {
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );
  const { isCreatorAppWebview, isListenerAppWebview, isEmbed } =
    useContext(UserAgentContext);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: '(max-width: 739px)' });
  const currentUser = useCurrentUser();

  const onMinimise = () => {
    dispatch(setMiniPlayerVisible(true));
  };

  if (!channel || isCreatorAppWebview) {
    return null;
  }

  const renderLinks = () => {
    if (isListenerAppWebview) {
      return null;
    } else {
      return (
        <div>
          {props.statusPill && props.statusPill}
          {props.minimiseUrl && (
            <IconLink
              showLabel={false}
              icon={'chevronDown'}
              label={'Minimize event'}
              href={props.minimiseUrl || '/'}
              onClick={onMinimise}
              isWhite={true}
            />
          )}
        </div>
      );
    }
  };

  return (
    <header
      className={classNames(styles['full-screen__header'], {
        [styles['full-screen__header--native']]: isListenerAppWebview
      })}
    >
      <div className={styles['full-screen__logo']}>
        <LogoImage
          size={isMobile || isEmbed ? 'small' : 'medium'}
          hasFallback={!channel.logoKey}
        >
          <ThumbImage
            artworkKey={channel.logoKey}
            artworkMode={'logo'}
            alt={`Logo for ${channel.username}`}
          />
        </LogoImage>
        <div className={styles['full-screen__logo__details']}>
          <h2
            className={classNames(
              'truncate',
              styles['full-screen__logo__title']
            )}
          >
            {channel.username}
          </h2>
          <div className={styles['full-screen__logo__links']}>
            <SupportButton showAslink={true} />
            <FollowButtons
              selectedProfileId={channel.ownerId}
              followedIds={(currentUser && currentUser.followedUserIds) || []}
              showAslink={true}
            />
          </div>
        </div>
      </div>
      {renderLinks()}
    </header>
  );
};
